<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-66">
			<form ref="absence_edit" @submit.prevent="updateAbsence">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<md-icon>edit</md-icon>
						</div>
						<h4 class="title">Modification d'une absence</h4>
					</md-card-header>
					<absence-form :absence="absence" :errors="errors"></absence-form>
					<md-card-actions md-alignment="left">
						<md-button type="submit" class="md-success">
							Enregistrer
						</md-button>
						<md-button class="md-warning"
								   @click="goBack">
							Retour
						</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</div>
	</div>
</template>

<script>
import AbsenceForm from "@/pages/Technicians/Absences/components/AbsenceForm";

export default {
	name: "AbsenceEdit",
	components: {
		AbsenceForm
	},
	data() {
		return {
			technicians: [],
			days: [],
			absenceTypes: [],
			absence: {
				idAbsenceType: null,
				idTechnician: null,
				dayNumber: null,
				start: null,
				end: null,
				comment: null,
				isArchived: null,
			},
			errors: []
		}
	},
	methods: {
		async getAbsenceDetails() {
			const { data } = await this.$store.dispatch('absences/getAbsenceDetails', { absence_id: this.$route.params.idAbsence })
			this.absence = {
				idAbsenceType: data.absence_type_id,
				idTechnician: data.user_id,
				dayNumber: data.day_number,
				start: this.$moment(data.date_start).format(),
				end: data.date_end ? this.$moment(data.date_end).format() : null,
				comment: data.comment,
				isArchived: !!data.is_archived
			}
		},
		async getTechnicians() {
			const { data } = await this.$store.dispatch('users/getTechnicians', {})
			this.technicians = data
		},
		async getAbsenceTypes() {
			const { data } = await this.$store.dispatch('absences/getAbsenceTypes')
			this.absenceTypes = data
		},
		async updateAbsence() {
			this.errors = []
			try {
				await this.$store.dispatch('absences/updateAbsence', {
					absence_id: this.$route.params.idAbsence,
					absence_type_id: this.absence.idAbsenceType,
					technician_id: this.absence.idTechnician,
					date_start: this.$moment(this.absence.start).format(),
					date_end: this.absence.end ? this.$moment(this.absence.end).format() : null,
					day_number: this.absence.dayNumber,
					comment: this.absence.comment,
					is_archived: this.absence.isArchived
				})
				await this.$store.dispatch('alerts/success', 'Absence modifiée')
				this.goBack()
			} catch (e) {
				await this.$store.dispatch('alerts/error', 'Modification impossible')
				this.errors = e.response.data.errors
			}
		},
		formatWeekdays() {
			let days = []
			this.$moment.weekdays(true).map(day => {
				days.push(day.charAt(0).toUpperCase() + day.slice(1))
			})
			days.pop()
			days.pop()
			this.days = days
		},
		goBack() {
			this.$router.back();
		}
	},
	mounted() {
		this.getAbsenceDetails()
		this.getTechnicians()
		this.getAbsenceTypes()
		this.formatWeekdays()
	}
}
</script>

<style scoped>

</style>
